import { render, staticRenderFns } from "./superAdminRegistration.vue?vue&type=template&id=abdd8476&scoped=true&"
import script from "./superAdminRegistration.vue?vue&type=script&lang=js&"
export * from "./superAdminRegistration.vue?vue&type=script&lang=js&"
import style0 from "./superAdminRegistration.vue?vue&type=style&index=0&id=abdd8476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdd8476",
  null
  
)

export default component.exports